import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Organizacion } from "@/shared/types/organizacion";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteOrganizacion(id: string): Promise<Organizacion> {
    await sleep(1000);
    const response = await api.delete("organizaciones/" + id);
    return response.data;
}

export function useDeleteOrganizacionMutation(id: string, mutationConfig: MutationConfig<Organizacion> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteOrganizacion(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["organizaciones"] });
        },
    })
}

export interface DeleteOrganizacionMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Organizacion>,
    children?: (mutationResult: MutationResult<Organizacion>) => ReactNode
}

export function DeleteOrganizacionMutation({
    id,
    children,
    mutationConfig
}: DeleteOrganizacionMutationProps) {
    const mutationResult = useDeleteOrganizacionMutation(id, mutationConfig);
    return children && children(mutationResult)
}